<div class="tab-container" #tabContainer>
  <div class="tab-menu" #tabMenu>
    <div
      *ngFor="let tab of tabs; trackBy: trackByIndex"
      class="tab-item"
      [class.active]="activeTab === tab.name"
      (click)="setActiveTab(tab.name)"
    >
      <img *ngIf="tab.icon" [src]="tab.icon" [alt]="tab.name" />
      <span>{{ tab.name }}</span>
    </div>
    <div class="toggle-container" *ngIf="hideStatsLabel">
      <span class="toggle-label">Hide Stats</span>
      <div class="toggle-switch" [class.active]="hideStats" (click)="toggleHideStats()">
        <div class="toggle-thumb"></div>
      </div>
    </div>
  </div>
  <button
    class="scroll-button left"
    (click)="scrollLeft()"
    *ngIf="showLeftScroll"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12L6 8L10 4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
  <button
    class="scroll-button right"
    (click)="scrollRight()"
    *ngIf="showRightScroll"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12L10 8L6 4"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</div>

<!-- Tab Content -->
<div class="tab-content">
  <ng-content></ng-content>
</div>
